import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import * as enrollmentActions from '../../../actions/enrollmentActions'

import ApproveEnrollmentModal from '../../classes/program-dashboard-manager/enrollments-tab/modals/ApproveEnrollmentModal'
import DropEnrollmentModal from '../../classes/program-dashboard-manager/enrollments-tab/modals/DropEnrollmentModal'

// Inline Approve/Decline for pending-approval rows (mirrors the drawer + program roster flow).
// Returns openers for the table and the rendered confirmation modals.
const useEnrollmentRowActions = ({ onActionComplete } = {}) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const [actionEnrollment, setActionEnrollment] = useState(null)
  const [actionModal, setActionModal] = useState(null) // 'approve' | 'decline' | null
  const [actionLoading, setActionLoading] = useState(false)
  const [coachMessage, setCoachMessage] = useState('')
  const [notifyViaEmail, setNotifyViaEmail] = useState(true)

  const openApproveModal = (enrollment) => { setActionEnrollment(enrollment); setActionModal('approve') }
  const openDeclineModal = (enrollment) => { setActionEnrollment(enrollment); setActionModal('decline') }
  const closeActionModal = () => {
    setActionModal(null)
    setActionEnrollment(null)
    setCoachMessage('')
    setNotifyViaEmail(true)
  }

  const handleApprove = () => {
    setActionLoading(true)
    dispatch(enrollmentActions.updateEnrollment({ enrollmentData: { id: actionEnrollment.id, status: 'active' }, coachMessage })).unwrap()
      .then(() => {
        toast.success(t('enrollmentsBilling.actions.enrollmentApproved'), { position: toast.POSITION.TOP_RIGHT })
        closeActionModal()
        onActionComplete?.()
      })
      .catch(() => toast.error(t('enrollmentsBilling.actions.somethingWentWrong'), { position: toast.POSITION.TOP_RIGHT }))
      .finally(() => setActionLoading(false))
  }

  const handleDecline = () => {
    setActionLoading(true)
    dispatch(enrollmentActions.deleteEnrollment({ enrollmentId: actionEnrollment.id, refund: false, coachMessage, notifyViaEmail })).unwrap()
      .then(() => {
        toast.success(t('enrollmentsBilling.actions.enrollmentDeclined'), { position: toast.POSITION.TOP_RIGHT })
        closeActionModal()
        onActionComplete?.()
      })
      .catch(() => toast.error(t('enrollmentsBilling.actions.somethingWentWrong'), { position: toast.POSITION.TOP_RIGHT }))
      .finally(() => setActionLoading(false))
  }

  const modals = (
    <>
      {actionModal === 'approve' && actionEnrollment && (
        <ApproveEnrollmentModal
          showModal
          closeModal={closeActionModal}
          coachMessage={coachMessage}
          handleCoachMessageChange={e => setCoachMessage(e.target.value)}
          handleApproveEnrollment={handleApprove}
          isLoading={actionLoading}
        />
      )}

      {actionModal === 'decline' && actionEnrollment && (
        <DropEnrollmentModal
          showModal
          closeModal={closeActionModal}
          coachMessage={coachMessage}
          handleCoachMessageChange={e => setCoachMessage(e.target.value)}
          handleRemoveEnrollment={handleDecline}
          enrollment={actionEnrollment}
          notifyViaEmail={notifyViaEmail}
          handleCheckboxChange={() => setNotifyViaEmail(notify => !notify)}
          isLoading={actionLoading}
        />
      )}
    </>
  )

  return { openApproveModal, openDeclineModal, modals }
}

export default useEnrollmentRowActions
